import React, { useState } from 'react';
import { PlayerTile } from './PlayerTile';

function SwitchTeamTile({ teamName, onClick }) {
  return (
    <button type="button"
      onClick={onClick}
      data-testid="player-picker-switch-team"
      className="relative flex flex-col items-center justify-center rounded-2xl px-3 py-3 sm:py-4 bg-[#0F1A4A] border-2 border-white/15 hover:border-amber-400/60 transition-all active:scale-[0.97]">
      <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-white/5 border border-white/30 flex items-center justify-center text-white/70 mb-1">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-8 h-8">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM3 19.5a6 6 0 1112 0 .75.75 0 01-.75.75H3.75A.75.75 0 013 19.5zM18 8.25a3 3 0 100 6 3 3 0 000-6zM21 21a4.5 4.5 0 00-7.395-3.434" />
        </svg>
      </div>
      <div className="text-white text-sm sm:text-base font-semibold text-center leading-tight">
        {teamName}
      </div>
    </button>
  );
}

// Shown after a stat tap; defaults to the active team's on-court players.
export function PlayerPicker({ statLabel, mainTeam, mainPlayers, otherTeam, otherPlayers, onCancel, onPick }) {
  const [showingTeam, setShowingTeam] = useState('main');
  const isMain = showingTeam === 'main';
  const players = isMain ? mainPlayers : otherPlayers;
  return (
    <div className="fixed inset-0 z-[105] bg-[#0A0F2C]/95 backdrop-blur-sm flex flex-col" data-testid="player-picker">
      <div className="flex items-start justify-between px-4 sm:px-6 pt-4 pb-2">
        <div className="flex-1 text-center">
          <div className="text-white text-lg sm:text-2xl font-semibold leading-snug">
            Choose player that stat belongs to
          </div>
          <div className="mt-1 text-emerald-300 text-sm sm:text-base font-medium">
            {statLabel} · <span className="text-white/70">{isMain ? mainTeam.name : otherTeam.name}</span>
          </div>
        </div>
        <button onClick={onCancel} className="text-white/70 hover:text-white text-sm font-medium" data-testid="player-picker-cancel">
          cancel
        </button>
      </div>
      <div className="flex-1 px-4 sm:px-6 pb-5 flex flex-col items-center justify-center">
        <div className="w-full max-w-5xl grid grid-cols-3 gap-3 sm:gap-4">
          {players.length === 0 ? (
            <div className="col-span-3 text-center text-white/60 py-10">
              No players on court. Pick a starting lineup from Game Settings first.
            </div>
          ) : players.map(p => (
            <PlayerTile
              key={p.id}
              player={p}
              onClick={() => onPick(p, showingTeam)}
              testId={`pick-player-${p.id}`}
            />
          ))}
          {players.length > 0 && (
            <SwitchTeamTile
              teamName={(isMain ? otherTeam : mainTeam).name}
              onClick={() => setShowingTeam(isMain ? 'other' : 'main')}
            />
          )}
        </div>
      </div>
    </div>
  );
}
